<template lang="pug">
    #payroll-list
        r-table( 
            no-data-text='Sin nominas de pago.'
            no-search  
            ref='table'
            remind-key='payroll-list'
            v-bind='tableProps' 
            @detail='submitDetail' 
            @remove='submitRemove' 
        )
            template( slot='actions' slot-scope='props' )
                r-action-btn(
                    color='secondary'
                    tooltip='Generar Previred'
                    @click='submitPrevired(props)'
                )
                    v-icon check_circle
                r-action-btn(
                    color='info'
                    :disabled='!props.item.can_download'
                    tooltip='Descargar Previred'
                    @click='submitDownload(props)'
                )
                    v-icon get_app 
                r-action-btn(
                    color='success'
                    tooltip='Descargar Excel'
                    @click='submitExcel(props)'
                )
                    v-icon cloud_download                    
            template( slot='prepend' )
                r-date-field(
                    :field-props='{ clearable: true }'
                    :picker-props='{ type: "month" }'
                    single-line
                    solo
                    style='max-width: 300px;'
                    v-model='date'
                )
                    strong( class='mr-1 mt-1' slot='prepend-inner' ) Periodo
        v-dialog( 
            :width='1280' 
            v-model='dialog' 
        )
            r-form(
                ref='form'
                reset-text='restablecer'
                submit-text='guardar'
                v-bind='formProps'
                v-model='selected'
                @reset='reset'
                @submit='submitUpdate'
            )
                template( slot='data-table-items' slot-scope='props' )
                    v-btn( 
                        color='success' 
                        v-if='!props.disabled'
                        @click='submitAdd' 
                    ) agregar &nbsp;
                        v-icon replay
                template( slot='footer-actions' slot-scope='props' )
                    v-btn( 
                        block 
                        class='ml-3' 
                        color='accent' 
                        :disabled='props.wait' 
                        @click='submitAuthorize' 
                    ) autorizar
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RActionBtn, RDateField, RForm, RTable } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
    import PayrollModel from '@/models/HumanResource/HrPayroll'
    import PayrollFields from '@/views/HumanResource/HrPayroll/HrPayrollFields'
    import PayrollFilters from '@/views/HumanResource/HrPayroll/HrPayrollFilters'
    import PayrollHeaders from '@/views/HumanResource/HrPayroll/HrPayrollHeaders'
    //
    export default {
        components: {
            RActionBtn,
            RDateField,
            RForm,
            RTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             * 
             */
            formProps() {
                return {
                    editable: false,
                    fields: PayrollFields,
                    title: `Nomina de sueldo #${this.selected.id}`,
                    switchEdit: this.selected.can_edit,
                }
            },

            /**
             * 
             */
            formFilter() {
                return {
                    can_be_added_to_payroll: true,
                    period_month: this.selected.payment_period_month,
                    period_year: this.selected.payment_period_year,
                }
            },

            /**
             * 
             */
            formParams() {
                return {
                    filter: this.formFilter,
                    get_all_results: true,
                }
            },

            /**
             * 
             */
            tableParamFilter() {
                return {
                    period_month: String(this.date).split('-').pop() ,
                    period_year: String(this.date).split('-').shift() ,
                }
            },

            /**
             *
             */
            tableProps() {
                return {
                    filters: PayrollFilters,
                    headers: PayrollHeaders,
                    service: PayrollModel,
                    paramFilter: this.date ? this.tableParamFilter : {}
                }
            },
        },
        data() {
            return {
                date: '',
                dialog: false,
                selected: {},
            }
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PayrollModel, error.response.data))
            },

            /**
             * 
             */
            refresh() {
                this.$refs.table.refresh()
            },
            
            /**
             *
             */
            reset() {
                this.selected = this.selected.reset()
            },

            /**
             * 
             */
            setDialog(dialog = false) {
                this.dialog = dialog
            },
            
            /**
             * 
             */
            setSelectedSelected({ data }) {
                this.selected.selected = data
            },

            /**
             * 
             */
            submitAdd() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toAdd)
                    .then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitAuthorize() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toAuthorize)
                    .then(this.$refs.form.setWait)                
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'payroll-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.dialog = true
                this.selected = event.item.reset()
                this.$refs.form.edit = false
            },

            /**
             *
             */
            submitDownload(event) {
                event.item.toPreviredExcel()
            },

            /**
             *
             */
            submitExcel(event) {
                event.item.toExcel()
            },

            /**
             *
             */
            submitPrevired(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en generar la planilla previred de la nomina de sueldo seleccionada?',
                    message: 'Una vez generada no se puede repetir este proceso.',
                    confirm: 'generar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            submitRemove(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en eliminar la nomina de sueldo seleccionada?',
                    message: 'Una vez eliminada no se puede recuperar.',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             *
             */
            submitUpdate() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .then(this.$refs.form.setWait)                
            },

            /**
             * 
             */
            successAuthorize() {
                this.setSuccessSnackbar('Nomina de sueldo autorizada exitosamente.')
            },

            /**
             * 
             */
            successPrevired() {
                this.setSuccessSnackbar('Planilla previred generada exitosamente.')
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Nomina de sueldo eliminada exitosamente.')
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Nomina de sueldo actualizada exitosamente.')
            },

            /**
             * 
             */
            toAdd(model) {
                return SalarySettlementModel
                    .modeler()
                    .params(this.formParams)
                    .get()
                    .then(this.setSelectedSelected)
            },

            /**
             * 
             */
            toAuthorize(model) {
                return model
                    .authorize()
                    .attach()
                    .then(this.successAuthorize)
                    .then(this.setDialog)
                    .then(this.refresh)
                    .catch(this.error)
            },

            /**
             * 
             */
            toPrevired() {
                this.selected
                    .previred()
                    .attach()
                    .then(this.successPrevired)
                    .then(this.refresh)
                    .catch(this.error)
            },

            /**
             * 
             */
            toRemove() {
                this.selected
                    .delete()
                    .then(this.successRemove)
                    .then(this.refresh)
                    .catch(this.error)
            },

            /**
             * 
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.setDialog)
                    .then(this.refresh)
                    .catch(this.error)
            },
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': return this.toRemove()
                    case 'generar': return this.toPrevired()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Nominas de sueldo')
            this.setItemsTopBar([
                {
                    text: 'agregar nomina de sueldo',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
            })
        },
    }
</script>
